import { render } from "./RomanNumerals.vue?vue&type=template&id=787d15ac"
import script from "./RomanNumerals.vue?vue&type=script&lang=js"
export * from "./RomanNumerals.vue?vue&type=script&lang=js"

import "./RomanNumerals.vue?vue&type=style&index=0&id=787d15ac&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__